import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCzWHFsI_3ZP1DC4k44cBZonSd6FAciAGM',
  authDomain: 'topmaterial-twinsketch.firebaseapp.com',
  projectId: 'topmaterial-twinsketch',
  storageBucket: 'topmaterial-twinsketch.firebasestorage.app',
  messagingSenderId: '527544819479',
  appId: '1:527544819479:web:c5c8bc560bcae33f77a152',
  measurementId: 'G-W499CCH020',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);

export { auth };
